/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Titlestart1Inputs */

const ja_careers_titlestart1 = /** @type {(inputs: Careers_Titlestart1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEVEL UP`)
};

const en_careers_titlestart1 = /** @type {(inputs: Careers_Titlestart1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEVEL UP`)
};

/**
* | output |
* | --- |
* | "LEVEL UP" |
*
* @param {Careers_Titlestart1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const careers_titlestart1 = /** @type {((inputs?: Careers_Titlestart1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Titlestart1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_titlestart1(inputs)
	return en_careers_titlestart1(inputs)
});
export { careers_titlestart1 as "careers_titleStart" }